import { FC, useContext } from 'react'
import StampSearch from '../../../../../../components/form-items/stamp-search/stamp-search'
import { EditableCellCtx } from '../../../../../../components/editable-cell/editable-cell'

interface StampSearchWrapperProps {}

const StampSearchWrapper: FC<StampSearchWrapperProps> = () => {
    const ctx = useContext(EditableCellCtx)

    // TODO: Возможно стоит добавить колонку материала в наличии под штамп

    return <StampSearch name={['stamp', 'set']} noStyle autoFocus onBlurOfFullField={ctx.onBlur} />
}

export default StampSearchWrapper
